import { Pipe, PipeTransform } from '@angular/core';
import { Usertest } from '@app/models/user';


@Pipe({
  name: 'userfilter'
})
export class UserfilterPipe implements PipeTransform {

  transform(users: Usertest[], searchTerm: string) {

    if (!searchTerm) {
      return null;
    }


   // tslint:disable-next-line:max-line-length
   return users.filter(user => user.firstName.toLowerCase().startsWith(searchTerm.toLowerCase()) || user.lastName.toLowerCase().startsWith(searchTerm.toLowerCase()) || user.Postnr.indexOf(searchTerm) !== -1);
  }

}
